module.exports = __webpack_public_path__ + "img/cent-dining-benefits_0.83086f50.jpg";